import { Action } from '@ngrx/store';
import { Address } from '../../model/address.model';

import { Contact, ContactAccount } from '../../model/contact.model';


export const SET_IS_CONTACT_CHECKED = 'SET_IS_CONTACT_CHECKED';
export const SET_LOGGED_IN_CONTACT = 'SET_LOGGED_IN_CONTACT';
export const RESET_LOGGED_IN_CONTACT = 'RESET_LOGGED_IN_CONTACT';
export const SET_DELIVERY_ADDRESS_SUGGESTIONS = 'SET_DELIVERY_ADDRESS_SUGGESTIONS';
export const GET_DELIVERY_ADDRESS_SUGGESTIONS = 'GET_DELIVERY_ADDRESS_SUGGESTIONS';

export const GET_LOGGED_IN_CONTACT = 'GET_LOGGED_IN_CONTACT';
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';
export const CLEAR_DELIVERY_ADDRESS_SUGGESTIONS = 'CLEAR_DELIVERY_ADDRESS_SUGGESTIONS';

export const REQUEST_ERROR = 'REQUEST_ERROR';
export const SET_TC_PORTAL_CONTACT = 'SET_TC_PORTAL_CONTACT';



export class SetIsContactChecked implements Action {
    readonly type = SET_IS_CONTACT_CHECKED;

    constructor(public value: boolean) {
    }
}

export class SetLoggedInContact implements Action {
    readonly type = SET_LOGGED_IN_CONTACT;

    constructor(public loggedInContact: Contact) {
    }
}

export class GetDeliveryAddressSuggestions implements Action {
    readonly type = GET_DELIVERY_ADDRESS_SUGGESTIONS;

    constructor() {
    }
}

export class SetDeliveryAddressSuggestions implements Action {
    readonly type = SET_DELIVERY_ADDRESS_SUGGESTIONS;

    constructor(public addresses: Address[]) {
    }
}



export class GetLoggedInContact implements Action {
    readonly type = GET_LOGGED_IN_CONTACT;

    constructor(public authId: string) {
    }
}
export class ClearContacts implements Action {
    readonly type = CLEAR_CONTACTS;

    constructor() {
    }
}

export class ResetLoggedInContact implements Action {
    readonly type = RESET_LOGGED_IN_CONTACT;

    constructor() {
    }
}

export class ClearDeliveryAddressSuggestions implements Action {
    readonly type = CLEAR_DELIVERY_ADDRESS_SUGGESTIONS;

    constructor() {
    }
}



export class RequestError implements Action {
    readonly type = REQUEST_ERROR;

    constructor(public error) {
    }
}

export class SetLoggedInContactTCPortalAccepted implements Action {
    readonly type = SET_TC_PORTAL_CONTACT;

    constructor(public value: boolean) {
    }
}

export type LabsysContactActions =
  SetLoggedInContact |
  SetDeliveryAddressSuggestions |
  GetDeliveryAddressSuggestions |

  GetLoggedInContact |
  ClearContacts |
  ClearDeliveryAddressSuggestions |
  RequestError |
  ResetLoggedInContact |
  SetIsContactChecked | SetLoggedInContactTCPortalAccepted;
